import { defineComponent as i, createElementBlock as o, openBlock as l, mergeProps as u, unref as e, renderSlot as m, createCommentVNode as g, createElementVNode as a } from "vue";
import { useScalarIcon as V } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, Z = { key: 1 }, f = { key: 2 }, M = { key: 3 }, L = { key: 4 }, k = { key: 5 }, y = {
  name: "ScalarIconPlay"
}, _ = /* @__PURE__ */ i({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = V(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      m(p.$slots, "default"),
      e(n) === "bold" ? (l(), o("g", A, t[0] || (t[0] = [
        a("path", { d: "M234.49,111.07,90.41,22.94A20,20,0,0,0,60,39.87V216.13a20,20,0,0,0,30.41,16.93l144.08-88.13a19.82,19.82,0,0,0,0-33.86ZM84,208.85V47.15L216.16,128Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (l(), o("g", Z, t[1] || (t[1] = [
        a("path", {
          d: "M228.23,134.69,84.15,222.81A8,8,0,0,1,72,216.12V39.88a8,8,0,0,1,12.15-6.69l144.08,88.12A7.82,7.82,0,0,1,228.23,134.69Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z" }, null, -1)
      ]))) : e(n) === "fill" ? (l(), o("g", f, t[2] || (t[2] = [
        a("path", { d: "M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z" }, null, -1)
      ]))) : e(n) === "light" ? (l(), o("g", M, t[3] || (t[3] = [
        a("path", { d: "M231.36,116.19,87.28,28.06a14,14,0,0,0-14.18-.27A13.69,13.69,0,0,0,66,39.87V216.13a13.69,13.69,0,0,0,7.1,12.08,14,14,0,0,0,14.18-.27l144.08-88.13a13.82,13.82,0,0,0,0-23.62Zm-6.26,13.38L81,217.7a2,2,0,0,1-2.06,0,1.78,1.78,0,0,1-1-1.61V39.87a1.78,1.78,0,0,1,1-1.61A2.06,2.06,0,0,1,80,38a2,2,0,0,1,1,.31L225.1,126.43a1.82,1.82,0,0,1,0,3.14Z" }, null, -1)
      ]))) : e(n) === "regular" ? (l(), o("g", L, t[4] || (t[4] = [
        a("path", { d: "M232.4,114.49,88.32,26.35a16,16,0,0,0-16.2-.3A15.86,15.86,0,0,0,64,39.87V216.13A15.94,15.94,0,0,0,80,232a16.07,16.07,0,0,0,8.36-2.35L232.4,141.51a15.81,15.81,0,0,0,0-27ZM80,215.94V40l143.83,88Z" }, null, -1)
      ]))) : e(n) === "thin" ? (l(), o("g", k, t[5] || (t[5] = [
        a("path", { d: "M230.32,117.9,86.24,29.79a11.91,11.91,0,0,0-12.17-.23A11.71,11.71,0,0,0,68,39.89V216.11a11.71,11.71,0,0,0,6.07,10.33,11.91,11.91,0,0,0,12.17-.23L230.32,138.1a11.82,11.82,0,0,0,0-20.2Zm-4.18,13.37L82.06,219.39a4,4,0,0,1-4.07.07,3.77,3.77,0,0,1-2-3.35V39.89a3.77,3.77,0,0,1,2-3.35,4,4,0,0,1,4.07.07l144.08,88.12a3.8,3.8,0,0,1,0,6.54Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  _ as default
};
